import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Loader2, Sparkles, CheckCircle2, AlertTriangle } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { VinconexLogo } from "@/components/VinconexMark";
import { Button } from "@/components/ui/button";

export default function UpgradeOneTap() {
  const [params] = useSearchParams();
  const [state, setState] = useState({ status: "loading" });

  useEffect(() => {
    const t = params.get("t");
    if (!t) {
      setState({ status: "error", message: "This upgrade link is missing its token." });
      return;
    }
    api
      .post("/public/addons/specialist-match/one-tap", { token: t })
      .then(({ data }) => setState({ status: "ok", ...data }))
      .catch((e) => setState({ status: "error", message: formatApiErrorDetail(e.response?.data?.detail) }));
  }, [params]);

  return (
    <div className="min-h-screen bg-[#0A0B0E] text-white flex flex-col items-center justify-center px-6 text-center">
      <VinconexLogo variant="full" className="h-24 w-auto" />
      <div data-testid="one-tap-result" className="mt-8 max-w-lg w-full rounded-2xl border border-[#2A2E3D] bg-[#12141C] p-8">
        {state.status === "loading" && <Loader2 className="h-8 w-8 animate-spin text-[#0A8CF2] mx-auto" />}
        {state.status === "ok" && (
          <>
            <CheckCircle2 className="h-12 w-12 text-emerald-400 mx-auto" />
            <h1 className="font-heading text-2xl sm:text-3xl font-black mt-4">
              {state.already_active ? "Specialist Match is already on" : "Request received"}
            </h1>
            <p className="text-slate-400 mt-3 text-sm sm:text-base">
              {state.already_active
                ? `${state.dealer_name} already has Specialist Match — shoppers are being matched right now.`
                : `Vinconex will activate Specialist Match for ${state.dealer_name} and let you know the moment it's live. No further action needed.`}
            </p>
            <div className="mt-6 inline-flex items-center gap-2 text-[11px] font-mono-tech uppercase tracking-widest text-[#7FC3FF]">
              <Sparkles className="h-3.5 w-3.5" /> Specialist Match add-on
            </div>
          </>
        )}
        {state.status === "error" && (
          <>
            <AlertTriangle className="h-12 w-12 text-amber-400 mx-auto" />
            <h1 className="font-heading text-2xl font-black mt-4">This link didn't work</h1>
            <p className="text-slate-400 mt-3 text-sm" data-testid="one-tap-error">{state.message}</p>
            <p className="text-slate-500 mt-2 text-xs">You can still request the add-on from your dashboard's Specialists page.</p>
          </>
        )}
        <Link to="/login" className="block mt-7">
          <Button data-testid="one-tap-dashboard-btn" className="bg-[#0A8CF2] hover:bg-[#3AA3FF] font-bold h-11 px-6">Open my dashboard</Button>
        </Link>
      </div>
    </div>
  );
}
